import Vue from 'vue';
import Vuex from 'vuex';
import VuexORM, {Database} from '@vuex-orm/core';

Vue.use(Vuex);

export const database = new Database();

require('$src/models');

export default new Vuex.Store({
    modules: require('$src/modules').default,
    plugins: [VuexORM.install(database)],
});